import DodStepperHeader from 'components/registration/dod/DodStepperHeader';
import DodWelcome from 'components/registration/dod/DodWelcome';
import DodPersonalInformation from 'components/registration/dod/DodPersonalInformation';
import DodOfficeAddress from 'components/registration/dod/DodOfficeAddress';
import DodCredentials from 'components/registration/dod/DodCredentials';
import DodSecurity from 'components/registration/dod/DodSecurity';
import DodAuthorization from 'components/registration/dod/DodAuthorization';
import DodReview from 'components/registration/dod/DodReview';
import tsaLogo from '@bit/ui-common.ui-components/afsp/images/dhs-logo-01.png';
import userIcon from '@bit/ui-common.ui-components/afsp/images/user-icon-01.png';
import { AfspReact } from '@bit/ui-common.ui-components/afsp';
import { SsStepper } from '@bit/ui-common.ui-components/ss-components';
import { buildCountrySelection, buildStateSelection } from 'utils/registration/formUtils';

const
{ Icon } = Ant,
{ SsStepperLayout, SsStep } = SsStepper;

let layoutConfig = {
    size: {
        header: 'xs',
        footer: 'xs'
    },
    images: {
        logo: tsaLogo,
        user: userIcon
    },
    controlType: 'home',
    bgc: '#f6f6f6'
};

export default class DodRegistrationLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = { context: this };
        this.buildCountrySelection = buildCountrySelection.bind(this);
        this.buildStateSelection = buildStateSelection.bind(this);
        this.updateTitle = this.updateTitle.bind(this);
        this.common = { utils: { updateTitle: this.updateTitle }};
    }

    updateTitle(stepNumber, icon, service, prevStatus, currStatus) {
        const
        title = s => (<div><Icon type={s} />{` Step ${stepNumber}`}</div>);
        if(prevStatus === 'invalid' && currStatus === 'valid') service(title('check-circle-o'));
        else if(prevStatus === 'valid' && currStatus === 'invalid') service(title(icon));
    }

    render() {
        const
        { dod, services, textData } = this.props,
        layout = {
            id: 'dod-registration',
            state: dod,
            services: services
        };
        
        return (
            <div>
                <AfspReact.Layout {...layoutConfig}>
                    <SsStepperLayout {...layout} header={(<DodStepperHeader text={textData.textDataStore} />)} progressDot>
                        <SsStep
                            id='welcome'
                            title={dod.welcome.title}
                            description={dod.welcome.description}
                            render={() => <DodWelcome 
                                dod={this.props.dod}
                                captcha={this.props.captcha}
                                passwordReset={this.props.passwordReset}
                                registrationForm={this.props.registrationForm}
                            />}
                        />
                        <SsStep
                            id='personalInformation'
                            title={dod.personalInformation.title}
                            description={dod.personalInformation.description}
                            render={() => <DodPersonalInformation
                                {...this.common}
                                registrationForm={this.props.registrationForm}
                            />}
                        />
                        <SsStep
                            id='officeAddress'
                            title={dod.officeAddress.title}
                            description={dod.officeAddress.description}
                            render={() => <DodOfficeAddress
                                geo={this.props.geo}
                                lookupData={this.props.lookupData}
                                registrationForm={this.props.registrationForm}
                                utils={{...this.common.utils,
                                    buildCountrySelection: this.buildCountrySelection,
                                    buildStateSelection: this.buildStateSelection
                                }}
                            />}
                        />
                        <SsStep
                            id='credentials'
                            title={dod.credentials.title}
                            description={dod.credentials.description}
                            render={() => <DodCredentials
                                {...this.common}
                                registrationForm={this.props.registrationForm}
                            />}
                        />
                        <SsStep
                            id='security'
                            title={dod.security.title}
                            description={dod.security.description}
                            render={() => <DodSecurity
                                {...this.common}
                                registrationForm={this.props.registrationForm}
                            />}
                        />
                        <SsStep
                            id='authorization'
                            title={dod.authorization.title}
                            description={dod.authorization.description}
                            render={() => <DodAuthorization
                                {...this.common}
                                registrationForm={this.props.registrationForm}
                            />}
                        />
                        <SsStep
                            fullState
                            id='review'
                            title={dod.review.title}
                            description={dod.review.description}
                            render={() => <DodReview
                                noErrorModal
                                {...this.common}
                                registrationForm={this.props.registrationForm}
                                captcha={this.props.captcha}
                            />}
                        />
                    </SsStepperLayout>
                </AfspReact.Layout>
            </div>
        )
    }
}
